import React from 'react'
import { useStep6Props } from './types'
import { wrap } from '../../../utils/globalUtils'
import Step6View from './views/Step6View'
import useStep6 from './hooks/useStep6'

const Step6: React.FC<useStep6Props> = wrap(Step6View, useStep6)
export default Step6
